import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import CampaignCreationSlideContainer from "../../../components/CampaignCreation/CampaignCreationSlideContainer";
import CampaignBasicDetailsForm, { FormInitialValues } from "./CampaignBasicDetailsForm";
import { BaseStepComponentProps } from "../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { setCampaignBasicDetails } from "../../../redux/reducers/campaignToCreate";

const CampaignBasicDetailsSlide: FC<BaseStepComponentProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
}) => {
  const campaignToCreate = useSelector((state: ReduxApplicationState) => state.campaignToCreate);

  const dispatch = useDispatch();

  const { basicDetails } = campaignToCreate!;

  const formInitialValues: FormInitialValues = {
    name: basicDetails.name,
    description: basicDetails.description,
    mediaType: basicDetails.isVideoCampaign ? "video" : "display",
    dailyBudget: basicDetails.dailyBudget,
    estimatedBudget: basicDetails.estimatedBudget,
    maxBid: basicDetails.maxBid,
    startDate: basicDetails.startDate,
    endDate: basicDetails.endDate,
    showInHubspot: basicDetails.showInHubspot,
    maxCompanies: basicDetails.maxCompanies,
  };

  const initialRef: any = null;
  const hiddenInnerSubmitFormRef = useRef(initialRef);

  const handleSubmit = async (values: FormInitialValues) => {
    try {
      const {
        name,
        description,
        mediaType,
        dailyBudget,
        estimatedBudget,
        maxBid,
        startDate,
        endDate,
        showInHubspot,
        maxCompanies,
      } = values;
      dispatch(
        setCampaignBasicDetails({
          name,
          description,
          dailyBudget: +dailyBudget,
          estimatedBudget: +estimatedBudget,
          maxBid: +maxBid,
          startDate,
          endDate,
          showInHubspot,
          maxCompanies: +maxCompanies,
          isVideoCampaign: mediaType === "video",
        }),
      );
      setIsAttemptingToGoNext(false);
      handleNext();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("setCampaignBasicDetails error: ", error);
    }
  };

  const handleInvalidSubmit = () => {
    setIsAttemptingToGoNext(false);
  };

  useEffect(() => {
    if (isAttemptingToGoNext) {
      hiddenInnerSubmitFormRef!.current!.click();
    }
  }, [handleNext, isAttemptingToGoNext, setIsAttemptingToGoNext]);

  return (
    <CampaignCreationSlideContainer heading="Campaign Details">
      <CampaignBasicDetailsForm
        formInitialValues={formInitialValues}
        handleSubmit={handleSubmit}
        handleInvalidSubmit={handleInvalidSubmit}
        ref={hiddenInnerSubmitFormRef}
      />
    </CampaignCreationSlideContainer>
  );
};

export default CampaignBasicDetailsSlide;
